/**
 * @group Functions
 * 
 * @summary
 * <blockquote>Converts error information into a standardized AppError object</blockquote>
 * 
 * @param {string} errorMessage - The error message to display
 * @param {string} details - Detailed description of the error
 * @param {string} code - Error code for programmatic handling
 * @returns {AppError} Structured application error object
 * 
 * @example
 * ```typescript
 * const error = convertToAppError(
 *   'User not found',
 *   'The requested user does not exist in the system',
 *   'USER_NOT_FOUND'
 * );
 * ```
 */
import type { AppError } from '../../error/types/AppError';

export function convertToAppError(
  errorMessage: string,
  details: string,
  code: string
): AppError {
  return {
    errorCode: code,
    errorMessage,
    details,
  };
} 